import { apiInstance } from "@/api/instance";

export default async function (counselId, data) {
  return apiInstance.post(`/counsel/${counselId}/comment`, data);
}
